<template>
    <AxRoadListItem
        :icon="truckIconUrl"
        :icon-color="iconColor"
        :primary-text="result.asset_name"
        :secondary-text="driverName"
        :to="
            to || {
                name: 'axRoadTruckDetails',
                params: { id: truck.id },
            }
        "
        :has-alert="hasWarnings"
    >
        <template #status>
            <div>
                {{ formatTime(result.start) }}
            </div>
            <div>
                {{ formatTime(result.end) }}
            </div>
        </template>
    </AxRoadListItem>
</template>

<script>
import { mapGetters } from 'vuex'

import AxRoadHelpers from '@/mixins/AxRoadHelpers'
import AxRoadListItem from '@/components/ax-road/AxRoadListItem'
import moment from 'moment'

export default {
    name: 'AxRoadTrucksListItem',
    components: {
        AxRoadListItem,
    },
    mixins: [AxRoadHelpers],
    props: {
        to: {
            type: [Object, String],
            default: null,
        },
        result: {
            type: Object, // { asset_id, asset_name, start, end }
            required: true,
        },
    },
    computed: {
        ...mapGetters('tracker', ['assetTypesById', 'assetsByAssetId']),
        ...mapGetters('warnings', ['assetWarningsMap']),
        truck() {
            return this.assetsByAssetId[this.result.asset_id]
        },
        truckAssetType() {
            return this.assetTypesById[this.truck.asset_details.asset_type]
        },
        iconColor() {
            return this.getAxRoadAssetColor(this.truck)
        },
        truckIconUrl() {
            return (
                this.truckAssetType.marker_ax_road?.url ||
                this.truckAssetType.marker.url
            )
        },
        driverName() {
            return this.truck.asset_details?.sensor_data?.driver_name?.value &&
                this.truck.asset_details.sensor_data.driver_1_card_presence &&
                this.truck.asset_details.sensor_data.driver_1_card_presence
                    .value === 1
                ? this.truck.asset_details?.sensor_data?.driver_name?.value
                : this.$t('noDriver')
        },
        hasWarnings() {
            return !!this.assetWarningsMap[this.truck.asset_details.id]
        },
    },
    methods: {
        formatTime(dateString) {
            return moment(dateString).format('HH:mm')
        },
    },
}
</script>

<i18n>
{
    "en": {
        "noDriver": "No driver"
    },
    "de": {
        "noDriver": "Kein Fahrer"
    },
    "fr": {
        "noDriver": "Pas de conducteur"
    },
    "it": {
        "noDriver": "Nessun conducente"
    }
}
</i18n>

<style lang="scss">
.trucks-list-item {
    &__time {
        max-width: 80px;
    }
    &__trailer-icon {
        filter: brightness(0.4);
    }
}
</style>
